// extracted by mini-css-extract-plugin
export default {"homeHeadings":"Home_homeHeadings__PKNfQ","gradientAnimation":"Home_gradientAnimation__bpB3P"};